import { FilterIcon } from './FilterIcon'
import { ArrowCircleUp } from 'common/components/Icons/ArrowCircleUp'

interface FilterTopBarProps {
  onClick: () => void
}

export const FilterTopBar = ({ onClick }: FilterTopBarProps) => {
  return (
    <div
      className='cursor-pointer w-full self-stretch flex justify-between items-center mb-4'
      onClick={onClick}
    >
      <div className='flex items-center gap-2'>
        <div className="justify-start text-[#001A3D] text-base font-medium font-['DM_Sans'] leading-normal tracking-wide">
          Filters
        </div>
        <div className='hidden md:block w-4 h-4 relative overflow-hidden'>
          <FilterIcon />
        </div>
      </div>
      <ArrowCircleUp />
    </div>
  )
}
